export const countries = [
  { name: 'Australia', value: 'Australia', alpha2: 'AU', alpha3: 'AUS' },
  { name: 'New Zealand', value: 'New Zealand', alpha2: 'NZ', alpha3: 'NZL' },
  {
    name: 'United States of America',
    value: 'United States of America',
    alpha2: 'US',
    alpha3: 'USA',
  },
  { name: 'Afghanistan', value: 'Afghanistan', alpha2: 'AF', alpha3: 'AFG' },
  { name: 'Aland Islands', value: 'Aland Islands', alpha2: 'AX', alpha3: 'ALA' },
  { name: 'Albania', value: 'Albania', alpha2: 'AL', alpha3: 'ALB' },
  { name: 'Algeria', value: 'Algeria', alpha2: 'DZ', alpha3: 'DZA' },
  { name: 'American Samoa', value: 'American Samoa', alpha2: 'AS', alpha3: 'ASM' },
  { name: 'Andorra', value: 'Andorra', alpha2: 'AD', alpha3: 'AND' },
  { name: 'Angola', value: 'Angola', alpha2: 'AO', alpha3: 'AGO' },
  { name: 'Anguilla', value: 'Anguilla', alpha2: 'AI', alpha3: 'AIA' },
  { name: 'Antigua & Barbuda', value: 'Antigua & Barbuda', alpha2: 'AG', alpha3: 'ATG' },
  { name: 'Argentina', value: 'Argentina', alpha2: 'AR', alpha3: 'ARG' },
  { name: 'Armenia', value: 'Armenia', alpha2: 'AM', alpha3: 'ARM' },
  { name: 'Aruba', value: 'Aruba', alpha2: 'AW', alpha3: 'ABW' },
  { name: 'Austria', value: 'Austria', alpha2: 'AT', alpha3: 'AUT' },
  { name: 'Azerbaijan', value: 'Azerbaijan', alpha2: 'AZ', alpha3: 'AZE' },
  { name: 'Bahamas', value: 'Bahamas', alpha2: 'BS', alpha3: 'BHS' },
  { name: 'Bahrain', value: 'Bahrain', alpha2: 'BH', alpha3: 'BHR' },
  { name: 'Bangladesh', value: 'Bangladesh', alpha2: 'BD', alpha3: 'BGD' },
  { name: 'Barbados', value: 'Barbados', alpha2: 'BB', alpha3: 'BRB' },
  { name: 'Belarus', value: 'Belarus', alpha2: 'BY', alpha3: 'BLR' },
  { name: 'Belgium', value: 'Belgium', alpha2: 'BE', alpha3: 'BEL' },
  { name: 'Belize', value: 'Belize', alpha2: 'BZ', alpha3: 'BLZ' },
  { name: 'Benin', value: 'Benin', alpha2: 'BJ', alpha3: 'BEN' },
  { name: 'Bermuda', value: 'Bermuda', alpha2: 'BM', alpha3: 'BMU' },
  { name: 'Bhutan', value: 'Bhutan', alpha2: 'BT', alpha3: 'BTN' },
  { name: 'Bolivia', value: 'Bolivia', alpha2: 'BO', alpha3: 'BOL' },
  { name: 'Bonaire', value: 'Bonaire', alpha2: 'BQ', alpha3: 'BES' },
  { name: 'Bosnia & Herzegovina', value: 'Bosnia & Herzegovina', alpha2: 'BA', alpha3: 'BIH' },
  { name: 'Botswana', value: 'Botswana', alpha2: 'BW', alpha3: 'BWA' },
  { name: 'Bouvet Island', value: 'Bouvet Island', alpha2: 'BV', alpha3: 'BVT' },
  { name: 'Brazil', value: 'Brazil', alpha2: 'BR', alpha3: 'BRA' },
  {
    name: 'British Indian Ocean Territory',
    value: 'British Indian Ocean Territory',
    alpha2: 'IO',
    alpha3: 'IOT',
  },
  { name: 'Brunei Darussalam', value: 'Brunei Darussalam', alpha2: 'BN', alpha3: 'BRN' },
  { name: 'Bulgaria', value: 'Bulgaria', alpha2: 'BG', alpha3: 'BGR' },
  { name: 'Burkina Faso', value: 'Burkina Faso', alpha2: 'BF', alpha3: 'BFA' },
  { name: 'Burundi', value: 'Burundi', alpha2: 'BI', alpha3: 'BDI' },
  { name: 'Cabo Verde', value: 'Cabo Verde', alpha2: 'CV', alpha3: 'CPV' },
  { name: 'Cambodia', value: 'Cambodia', alpha2: 'KH', alpha3: 'KHM' },
  { name: 'Cameroon', value: 'Cameroon', alpha2: 'CM', alpha3: 'CMR' },
  { name: 'Canada', value: 'Canada', alpha2: 'CA', alpha3: 'CAN' },
  { name: 'Cayman Islands', value: 'Cayman Islands', alpha2: 'KY', alpha3: 'CYM' },
  {
    name: 'Central African Republic',
    value: 'Central African Republic',
    alpha2: 'CF',
    alpha3: 'CAF',
  },
  { name: 'Chad', value: 'Chad', alpha2: 'TD', alpha3: 'TCD' },
  { name: 'Chile', value: 'Chile', alpha2: 'CL', alpha3: 'CHL' },
  { name: 'China', value: 'China', alpha2: 'CN', alpha3: 'CHN' },
  { name: 'Christmas Island', value: 'Christmas Island', alpha2: 'CX', alpha3: 'CXR' },
  {
    name: 'Cocos (Keeling) Islands',
    value: 'Cocos (Keeling) Islands',
    alpha2: 'CC',
    alpha3: 'CCK',
  },
  { name: 'Colombia', value: 'Colombia', alpha2: 'CO', alpha3: 'COL' },
  { name: 'Comoros', value: 'Comoros', alpha2: 'KM', alpha3: 'COM' },
  {
    name: 'Congo (Democratic Republic)',
    value: 'Congo (Democratic Republic)',
    alpha2: 'CD',
    alpha3: 'COD',
  },
  { name: 'Congo (Republic)', value: 'Congo (Republic)', alpha2: 'CG', alpha3: 'COG' },
  { name: 'Cook Islands', value: 'Cook Islands', alpha2: 'CK', alpha3: 'COK' },
  { name: 'Costa Rica', value: 'Costa Rica', alpha2: 'CR', alpha3: 'CRI' },
  { name: "Côte d'Ivoire", value: "Côte d'Ivoire", alpha2: 'CI', alpha3: 'CIV' },
  { name: 'Croatia', value: 'Croatia', alpha2: 'HR', alpha3: 'HRV' },
  { name: 'Cuba', value: 'Cuba', alpha2: 'CU', alpha3: 'CUB' },
  { name: 'Curacao', value: 'Curacao', alpha2: 'CW', alpha3: 'CUW' },
  { name: 'Cyprus', value: 'Cyprus', alpha2: 'CY', alpha3: 'CYP' },
  { name: 'Czechia', value: 'Czechia', alpha2: 'CZ', alpha3: 'CZE' },
  { name: 'Denmark', value: 'Denmark', alpha2: 'DK', alpha3: 'DNK' },
  { name: 'Djibouti', value: 'Djibouti', alpha2: 'DJ', alpha3: 'DJI' },
  { name: 'Dominica', value: 'Dominica', alpha2: 'DM', alpha3: 'DMA' },
  { name: 'Dominican Republic', value: 'Dominican Republic', alpha2: 'DO', alpha3: 'DOM' },
  { name: 'Ecuador', value: 'Ecuador', alpha2: 'EC', alpha3: 'ECU' },
  { name: 'Egypt', value: 'Egypt', alpha2: 'EG', alpha3: 'EGY' },
  { name: 'El Salvador', value: 'El Salvador', alpha2: 'SV', alpha3: 'SLV' },
  { name: 'Equatorial Guinea', value: 'Equatorial Guinea', alpha2: 'GQ', alpha3: 'GNQ' },
  { name: 'Eritrea', value: 'Eritrea', alpha2: 'ER', alpha3: 'ERI' },
  { name: 'Estonia', value: 'Estonia', alpha2: 'EE', alpha3: 'EST' },
  { name: 'Eswatini', value: 'Eswatini', alpha2: 'SZ', alpha3: 'SWZ' },
  { name: 'Ethiopia', value: 'Ethiopia', alpha2: 'ET', alpha3: 'ETH' },
  {
    name: 'Falkland Islands (Malvinas)',
    value: 'Falkland Islands (Malvinas)',
    alpha2: 'FK',
    alpha3: 'FLK',
  },
  { name: 'Faroe Islands', value: 'Faroe Islands', alpha2: 'FO', alpha3: 'FRO' },
  { name: 'Fiji', value: 'Fiji', alpha2: 'FJ', alpha3: 'FJI' },
  { name: 'Finland', value: 'Finland', alpha2: 'FI', alpha3: 'FIN' },
  { name: 'France', value: 'France', alpha2: 'FR', alpha3: 'FRA' },
  { name: 'French Guiana', value: 'French Guiana', alpha2: 'GF', alpha3: 'GUF' },
  { name: 'French Polynesia', value: 'French Polynesia', alpha2: 'PF', alpha3: 'PYF' },
  {
    name: 'French Southern Territories',
    value: 'French Southern Territories',
    alpha2: 'TF',
    alpha3: 'ATF',
  },
  { name: 'Gabon', value: 'Gabon', alpha2: 'GA', alpha3: 'GAB' },
  { name: 'Gambia', value: 'Gambia', alpha2: 'GM', alpha3: 'GMB' },
  { name: 'Georgia', value: 'Georgia', alpha2: 'GE', alpha3: 'GEO' },
  { name: 'Germany', value: 'Germany', alpha2: 'DE', alpha3: 'DEU' },
  { name: 'Ghana', value: 'Ghana', alpha2: 'GH', alpha3: 'GHA' },
  { name: 'Gibraltar', value: 'Gibraltar', alpha2: 'GI', alpha3: 'GIB' },
  { name: 'Greece', value: 'Greece', alpha2: 'GR', alpha3: 'GRC' },
  { name: 'Greenland', value: 'Greenland', alpha2: 'GL', alpha3: 'GRL' },
  { name: 'Grenada', value: 'Grenada', alpha2: 'GD', alpha3: 'GRD' },
  { name: 'Guadeloupe', value: 'Guadeloupe', alpha2: 'GP', alpha3: 'GLP' },
  { name: 'Guam', value: 'Guam', alpha2: 'GU', alpha3: 'GUM' },
  { name: 'Guatemala', value: 'Guatemala', alpha2: 'GT', alpha3: 'GTM' },
  { name: 'Guernsey', value: 'Guernsey', alpha2: 'GG', alpha3: 'GGY' },
  { name: 'Guinea', value: 'Guinea', alpha2: 'GN', alpha3: 'GIN' },
  { name: 'Guinea-Bissau', value: 'Guinea-Bissau', alpha2: 'GW', alpha3: 'GNB' },
  { name: 'Guyana', value: 'Guyana', alpha2: 'GY', alpha3: 'GUY' },
  { name: 'Haiti', value: 'Haiti', alpha2: 'HT', alpha3: 'HTI' },
  {
    name: 'Heard Island & McDonald Islands',
    value: 'Heard Island & McDonald Islands',
    alpha2: 'HM',
    alpha3: 'HMD',
  },
  {
    name: 'Holy See (Vatican City State)',
    value: 'Holy See (Vatican City State)',
    alpha2: 'VA',
    alpha3: 'VAT',
  },
  { name: 'Honduras', value: 'Honduras', alpha2: 'HN', alpha3: 'HND' },
  { name: 'Hong Kong', value: 'Hong Kong', alpha2: 'HK', alpha3: 'HKG' },
  { name: 'Hungary', value: 'Hungary', alpha2: 'HU', alpha3: 'HUN' },
  { name: 'Iceland', value: 'Iceland', alpha2: 'IS', alpha3: 'ISL' },
  { name: 'India', value: 'India', alpha2: 'IN', alpha3: 'IND' },
  { name: 'Indonesia', value: 'Indonesia', alpha2: 'ID', alpha3: 'IDN' },
  { name: 'Iran', value: 'Iran', alpha2: 'IR', alpha3: 'IRN' },
  { name: 'Iraq', value: 'Iraq', alpha2: 'IQ', alpha3: 'IRQ' },
  { name: 'Ireland', value: 'Ireland', alpha2: 'IE', alpha3: 'IRL' },
  { name: 'Isle of Man', value: 'Isle of Man', alpha2: 'IM', alpha3: 'IMN' },
  { name: 'Israel', value: 'Israel', alpha2: 'IL', alpha3: 'ISR' },
  { name: 'Italy', value: 'Italy', alpha2: 'IT', alpha3: 'ITA' },
  { name: 'Jamaica', value: 'Jamaica', alpha2: 'JM', alpha3: 'JAM' },
  { name: 'Japan', value: 'Japan', alpha2: 'JP', alpha3: 'JPN' },
  { name: 'Jersey', value: 'Jersey', alpha2: 'JE', alpha3: 'JEY' },
  { name: 'Jordan', value: 'Jordan', alpha2: 'JO', alpha3: 'JOR' },
  { name: 'Kazakhstan', value: 'Kazakhstan', alpha2: 'KZ', alpha3: 'KAZ' },
  { name: 'Kenya', value: 'Kenya', alpha2: 'KE', alpha3: 'KEN' },
  { name: 'Kiribati', value: 'Kiribati', alpha2: 'KI', alpha3: 'KIR' },
  {
    name: 'Korea (Democratic Republic)',
    value: 'Korea (Democratic Republic)',
    alpha2: 'KP',
    alpha3: 'PRK',
  },
  { name: 'Korea (Republic)', value: 'Korea (Republic)', alpha2: 'KR', alpha3: 'KOR' },
  { name: 'Kuwait', value: 'Kuwait', alpha2: 'KW', alpha3: 'KWT' },
  { name: 'Kyrgyzstan', value: 'Kyrgyzstan', alpha2: 'KG', alpha3: 'KGZ' },
  { name: 'Laos', value: 'Laos', alpha2: 'LA', alpha3: 'LAO' },
  { name: 'Latvia', value: 'Latvia', alpha2: 'LV', alpha3: 'LVA' },
  { name: 'Lebanon', value: 'Lebanon', alpha2: 'LB', alpha3: 'LBN' },
  { name: 'Lesotho', value: 'Lesotho', alpha2: 'LS', alpha3: 'LSO' },
  { name: 'Liberia', value: 'Liberia', alpha2: 'LR', alpha3: 'LBR' },
  { name: 'Libya', value: 'Libya', alpha2: 'LY', alpha3: 'LBY' },
  { name: 'Liechtenstein', value: 'Liechtenstein', alpha2: 'LI', alpha3: 'LIE' },
  { name: 'Lithuania', value: 'Lithuania', alpha2: 'LT', alpha3: 'LTU' },
  { name: 'Luxembourg', value: 'Luxembourg', alpha2: 'LU', alpha3: 'LUX' },
  { name: 'Macao', value: 'Macao', alpha2: 'MO', alpha3: 'MAC' },
  { name: 'Madagascar', value: 'Madagascar', alpha2: 'MG', alpha3: 'MDG' },
  { name: 'Malawi', value: 'Malawi', alpha2: 'MW', alpha3: 'MWI' },
  { name: 'Malaysia', value: 'Malaysia', alpha2: 'MY', alpha3: 'MYS' },
  { name: 'Maldives', value: 'Maldives', alpha2: 'MV', alpha3: 'MDV' },
  { name: 'Mali', value: 'Mali', alpha2: 'ML', alpha3: 'MLI' },
  { name: 'Malta', value: 'Malta', alpha2: 'MT', alpha3: 'MLT' },
  { name: 'Marshall Islands', value: 'Marshall Islands', alpha2: 'MH', alpha3: 'MHL' },
  { name: 'Martinique', value: 'Martinique', alpha2: 'MQ', alpha3: 'MTQ' },
  { name: 'Mauritania', value: 'Mauritania', alpha2: 'MR', alpha3: 'MRT' },
  { name: 'Mauritius', value: 'Mauritius', alpha2: 'MU', alpha3: 'MUS' },
  { name: 'Mayotte', value: 'Mayotte', alpha2: 'YT', alpha3: 'MYT' },
  { name: 'Mexico', value: 'Mexico', alpha2: 'MX', alpha3: 'MEX' },
  { name: 'Micronesia', value: 'Micronesia', alpha2: 'FM', alpha3: 'FSM' },
  { name: 'Moldova', value: 'Moldova', alpha2: 'MD', alpha3: 'MDA' },
  { name: 'Monaco', value: 'Monaco', alpha2: 'MC', alpha3: 'MCO' },
  { name: 'Mongolia', value: 'Mongolia', alpha2: 'MN', alpha3: 'MNG' },
  { name: 'Montenegro', value: 'Montenegro', alpha2: 'ME', alpha3: 'MNE' },
  { name: 'Montserrat', value: 'Montserrat', alpha2: 'MS', alpha3: 'MSR' },
  { name: 'Morocco', value: 'Morocco', alpha2: 'MA', alpha3: 'MAR' },
  { name: 'Mozambique', value: 'Mozambique', alpha2: 'MZ', alpha3: 'MOZ' },
  { name: 'Myanmar', value: 'Myanmar', alpha2: 'MM', alpha3: 'MMR' },
  { name: 'Namibia', value: 'Namibia', alpha2: 'NA', alpha3: 'NAM' },
  { name: 'Nauru', value: 'Nauru', alpha2: 'NR', alpha3: 'NRU' },
  { name: 'Nepal', value: 'Nepal', alpha2: 'NP', alpha3: 'NPL' },
  { name: 'Netherlands', value: 'Netherlands', alpha2: 'NL', alpha3: 'NLD' },
  { name: 'New Caledonia', value: 'New Caledonia', alpha2: 'NC', alpha3: 'NCL' },
  { name: 'Nicaragua', value: 'Nicaragua', alpha2: 'NI', alpha3: 'NIC' },
  { name: 'Niger', value: 'Niger', alpha2: 'NE', alpha3: 'NER' },
  { name: 'Nigeria', value: 'Nigeria', alpha2: 'NG', alpha3: 'NGA' },
  { name: 'Niue', value: 'Niue', alpha2: 'NU', alpha3: 'NIU' },
  { name: 'Norfolk Island', value: 'Norfolk Island', alpha2: 'NF', alpha3: 'NFK' },
  { name: 'North Macedonia', value: 'North Macedonia', alpha2: 'MK', alpha3: 'MKD' },
  {
    name: 'Northern Mariana Islands',
    value: 'Northern Mariana Islands',
    alpha2: 'MP',
    alpha3: 'MNP',
  },
  { name: 'Norway', value: 'Norway', alpha2: 'NO', alpha3: 'NOR' },
  { name: 'Oman', value: 'Oman', alpha2: 'OM', alpha3: 'OMN' },
  { name: 'Pakistan', value: 'Pakistan', alpha2: 'PK', alpha3: 'PAK' },
  { name: 'Palau', value: 'Palau', alpha2: 'PW', alpha3: 'PLW' },
  { name: 'Palestine', value: 'Palestine', alpha2: 'PS', alpha3: 'PSE' },
  { name: 'Panama', value: 'Panama', alpha2: 'PA', alpha3: 'PAN' },
  { name: 'Papua New Guinea', value: 'Papua New Guinea', alpha2: 'PG', alpha3: 'PNG' },
  { name: 'Paraguay', value: 'Paraguay', alpha2: 'PY', alpha3: 'PRY' },
  { name: 'Peru', value: 'Peru', alpha2: 'PE', alpha3: 'PER' },
  { name: 'Philippines', value: 'Philippines', alpha2: 'PH', alpha3: 'PHL' },
  { name: 'Pitcairn', value: 'Pitcairn', alpha2: 'PN', alpha3: 'PCN' },
  { name: 'Poland', value: 'Poland', alpha2: 'PL', alpha3: 'POL' },
  { name: 'Portugal', value: 'Portugal', alpha2: 'PT', alpha3: 'PRT' },
  { name: 'Puerto Rico', value: 'Puerto Rico', alpha2: 'PR', alpha3: 'PRI' },
  { name: 'Qatar', value: 'Qatar', alpha2: 'QA', alpha3: 'QAT' },
  { name: 'Réunion', value: 'Réunion', alpha2: 'RE', alpha3: 'REU' },
  { name: 'Romania', value: 'Romania', alpha2: 'RO', alpha3: 'ROU' },
  { name: 'Russia', value: 'Russia', alpha2: 'RU', alpha3: 'RUS' },
  { name: 'Rwanda', value: 'Rwanda', alpha2: 'RW', alpha3: 'RWA' },
  { name: 'Saint Barthélemy', value: 'Saint Barthélemy', alpha2: 'BL', alpha3: 'BLM' },
  { name: 'Saint Helena', value: 'Saint Helena', alpha2: 'SH', alpha3: 'SHN' },
  { name: 'Saint Kitts & Nevis', value: 'Saint Kitts & Nevis', alpha2: 'KN', alpha3: 'KNA' },
  { name: 'Saint Lucia', value: 'Saint Lucia', alpha2: 'LC', alpha3: 'LCA' },
  { name: 'Saint Martin', value: 'Saint Martin', alpha2: 'MF', alpha3: 'MAF' },
  {
    name: 'Saint Pierre & Miquelon',
    value: 'Saint Pierre & Miquelon',
    alpha2: 'PM',
    alpha3: 'SPM',
  },
  {
    name: 'Saint Vincent & The Grenadines',
    value: 'Saint Vincent & The Grenadines',
    alpha2: 'VC',
    alpha3: 'VCT',
  },
  { name: 'Samoa', value: 'Samoa', alpha2: 'WS', alpha3: 'WSM' },
  { name: 'San Marino', value: 'San Marino', alpha2: 'SM', alpha3: 'SMR' },
  { name: 'Sao Tome & Principe', value: 'Sao Tome & Principe', alpha2: 'ST', alpha3: 'STP' },
  { name: 'Saudi Arabia', value: 'Saudi Arabia', alpha2: 'SA', alpha3: 'SAU' },
  { name: 'Senegal', value: 'Senegal', alpha2: 'SN', alpha3: 'SEN' },
  { name: 'Serbia', value: 'Serbia', alpha2: 'RS', alpha3: 'SRB' },
  { name: 'Seychelles', value: 'Seychelles', alpha2: 'SC', alpha3: 'SYC' },
  { name: 'Sierra Leone', value: 'Sierra Leone', alpha2: 'SL', alpha3: 'SLE' },
  { name: 'Singapore', value: 'Singapore', alpha2: 'SG', alpha3: 'SGP' },
  { name: 'Sint Maarten', value: 'Sint Maarten', alpha2: 'SX', alpha3: 'SXM' },
  { name: 'Slovakia', value: 'Slovakia', alpha2: 'SK', alpha3: 'SVK' },
  { name: 'Slovenia', value: 'Slovenia', alpha2: 'SI', alpha3: 'SVN' },
  { name: 'Solomon Islands', value: 'Solomon Islands', alpha2: 'SB', alpha3: 'SLB' },
  { name: 'Somalia', value: 'Somalia', alpha2: 'SO', alpha3: 'SOM' },
  { name: 'South Africa', value: 'South Africa', alpha2: 'ZA', alpha3: 'ZAF' },
  {
    name: 'South Georgia & South Sandwich Islands',
    value: 'South Georgia & South Sandwich Islands',
    alpha2: 'GS',
    alpha3: 'SGS',
  },
  { name: 'South Sudan', value: 'South Sudan', alpha2: 'SS', alpha3: 'SSD' },
  { name: 'Spain', value: 'Spain', alpha2: 'ES', alpha3: 'ESP' },
  { name: 'Sri Lanka', value: 'Sri Lanka', alpha2: 'LK', alpha3: 'LKA' },
  { name: 'Sudan', value: 'Sudan', alpha2: 'SD', alpha3: 'SDN' },
  { name: 'Suriname', value: 'Suriname', alpha2: 'SR', alpha3: 'SUR' },
  { name: 'Svalbard & Jan Mayen', value: 'Svalbard & Jan Mayen', alpha2: 'SJ', alpha3: 'SJM' },
  { name: 'Sweden', value: 'Sweden', alpha2: 'SE', alpha3: 'SWE' },
  { name: 'Switzerland', value: 'Switzerland', alpha2: 'CH', alpha3: 'CHE' },
  { name: 'Syrian Arab Republic', value: 'Syrian Arab Republic', alpha2: 'SY', alpha3: 'SYR' },
  { name: 'Taiwan', value: 'Taiwan', alpha2: 'TW', alpha3: 'TWN' },
  { name: 'Tajikistan', value: 'Tajikistan', alpha2: 'TJ', alpha3: 'TJK' },
  { name: 'Tanzania', value: 'Tanzania', alpha2: 'TZ', alpha3: 'TZA' },
  { name: 'Thailand', value: 'Thailand', alpha2: 'TH', alpha3: 'THA' },
  { name: 'Timor-Leste', value: 'Timor-Leste', alpha2: 'TL', alpha3: 'TLS' },
  { name: 'Togo', value: 'Togo', alpha2: 'TG', alpha3: 'TGO' },
  { name: 'Tokelau', value: 'Tokelau', alpha2: 'TK', alpha3: 'TKL' },
  { name: 'Tonga', value: 'Tonga', alpha2: 'TO', alpha3: 'TON' },
  { name: 'Trinidad & Tobago', value: 'Trinidad & Tobago', alpha2: 'TT', alpha3: 'TTO' },
  { name: 'Tunisia', value: 'Tunisia', alpha2: 'TN', alpha3: 'TUN' },
  { name: 'Turkey', value: 'Turkey', alpha2: 'TR', alpha3: 'TUR' },
  { name: 'Turkmenistan', value: 'Turkmenistan', alpha2: 'TM', alpha3: 'TKM' },
  { name: 'Turks & Caicos Islands', value: 'Turks & Caicos Islands', alpha2: 'TC', alpha3: 'TCA' },
  { name: 'Tuvalu', value: 'Tuvalu', alpha2: 'TV', alpha3: 'TUV' },
  { name: 'Uganda', value: 'Uganda', alpha2: 'UG', alpha3: 'UGA' },
  { name: 'Ukraine', value: 'Ukraine', alpha2: 'UA', alpha3: 'UKR' },
  { name: 'United Arab Emirates', value: 'United Arab Emirates', alpha2: 'AE', alpha3: 'ARE' },
  { name: 'United Kingdom', value: 'United Kingdom', alpha2: 'GB', alpha3: 'GBR' },
  {
    name: 'United States Minor Outlying Islands',
    value: 'United States Minor Outlying Islands',
    alpha2: 'UM',
    alpha3: 'UMI',
  },
  { name: 'Uruguay', value: 'Uruguay', alpha2: 'UY', alpha3: 'URY' },
  { name: 'Uzbekistan', value: 'Uzbekistan', alpha2: 'UZ', alpha3: 'UZB' },
  { name: 'Vanuatu', value: 'Vanuatu', alpha2: 'VU', alpha3: 'VUT' },
  { name: 'Venezuela', value: 'Venezuela', alpha2: 'VE', alpha3: 'VEN' },
  { name: 'Vietnam', value: 'Vietnam', alpha2: 'VN', alpha3: 'VNM' },
  {
    name: 'Virgin Islands (British)',
    value: 'Virgin Islands (British)',
    alpha2: 'VG',
    alpha3: 'VGB',
  },
  { name: 'Virgin Islands (U.S.)', value: 'Virgin Islands (U.S.)', alpha2: 'VI', alpha3: 'VIR' },
  { name: 'Wallis & Futuna', value: 'Wallis & Futuna', alpha2: 'WF', alpha3: 'WLF' },
  { name: 'Western Sahara', value: 'Western Sahara', alpha2: 'EH', alpha3: 'ESH' },
  { name: 'Yemen', value: 'Yemen', alpha2: 'YE', alpha3: 'YEM' },
  { name: 'Zambia', value: 'Zambia', alpha2: 'ZM', alpha3: 'ZMB' },
  { name: 'Zimbabwe', value: 'Zimbabwe', alpha2: 'ZW', alpha3: 'ZWE' },
];
